"use strict";
import { jsx } from "react/jsx-runtime";
import { ActivityStream } from "../accounts_payable/activity_streams";
export default {
  invoiceActivity: function(activityItems) {
    return /* @__PURE__ */ jsx(ActivityStream, { items: activityItems });
  }
};
